import { CONFIG_REQUEST, CONFIG_SUCCESS, CONFIG_FAILURE } from '../actions/types';

const initialState = {
  countries: [],
  loading: false,
  error: undefined,
  features: {},
  experiments: {},
};

export default function configReducer(state = initialState, action = {}) {
  switch (action.type) {
    case CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CONFIG_SUCCESS:
      return {
        ...state,
        features: action.payload.features,
        experiments: action.payload.ab_tests,
        loading: false,
        countries: Object.keys(action.payload.country_info).map((localeKey) => {
          const locale = action.payload.country_info[localeKey];
          return {
            id: localeKey,
            name: locale.localized_name,
            host: locale.host,
            personalNames: locale.personal_names,
            roovite: {
              inviteeAmount: locale.roovite.invitee_amount,
              referrerAmount: locale.roovite.referrer_amount,
              currencySymbol: locale.roovite.currency_symbol,
              currencyCode: locale.roovite.currency_code,
              inviteeSteps: locale.roovite.invitee_steps,
              referrerSteps: locale.roovite.referrer_steps,
              creditExpiry: locale.roovite.credit_expiry,
              minimumOrderValue: locale.roovite.minimum_order_value,
            },
            social: {
              twitter: locale.contact.social.twitter,
              instagram: locale.contact.social.instagram,
              facebook: locale.contact.social.facebook,
              facebookShareId: locale.contact.social.facebook_share_id,
            },
            blog: locale.contact.blog,
            newsroomLink: locale.contact.newsroom_link,
            careersLink: locale.contact.careers_link,
          };
        }),
        rooStickyGuid: action.payload.sticky_guid,
        error: undefined,
      };
    case CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          status: action.status,
          message: action.message,
        },
      };
    default:
      return state;
  }
}
